var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15.8334,
    height: 29.1668,
    viewBox: "0 0 15.8334 29.1668",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M13.6995 0.366116C14.1876 -0.122039 14.9789 -0.122039 15.467 0.366116C15.9552 0.854272 15.9552 1.64554 15.467 2.13369L3.01748 14.5832L15.467 27.0328L15.5533 27.1272C15.9538 27.6182 15.9247 28.3427 15.467 28.8004C15.0094 29.258 14.2848 29.2871 13.7939 28.8866L13.6995 28.8004L0.366116 15.467C-0.122039 14.9789 -0.122039 14.1876 0.366116 13.6995L13.6995 0.366116Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.94ff582717980e750abddb80e3a4b3ce.svg";
export { ForwardRef as ReactComponent };